import styled from 'styled-components';

export const StyledTitle = styled.h2`
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 36px;
  line-height: 1.1;

  @media ${({ theme }) => theme.media.tablet} {
    font-size: 40px;
    margin-bottom: 40px;
  }
`;
